const Google_Analytics = {

    Tracking_Id : 'UA-184224042-1'
}

export default Google_Analytics 